exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___3ebm4 {\n  padding-top: 40px;\n  padding-bottom: 80px;\n  background-color: #f9fafc;\n  background-image: url(" + require("../../../../assets/images/dashboard/confetti_modal.svg") + ");\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.title___3uIxs {\n  font-size: 32px;\n  line-height: 44px;\n  font-family: 'poynter-oldstyle-display', serif;\n  text-align: center;\n}\n.subtitle___3QrWs {\n  text-align: center;\n  font-size: 20px;\n  line-height: 32px;\n  color: #505050;\n  font-weight: 600;\n  margin: 40px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___3ebm4",
	"title": "title___3uIxs",
	"subtitle": "subtitle___3QrWs"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/common/modals/PlanningDashboardTourModal/PlanningDashboardTourModal.module.less
// module id = 2722
// module chunks = 70